import { categories } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

export default function Categories() {
  return (
    <section id="cats" className="scroll-mt-16 bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="内容分类"
            title="想吃什么瓜，先看这里"
            desc="按主题把散落各处的截图与讨论归到一个档案夹，找起来更快、脉络更清楚。"
          />
          <a
            href="#latest"
            className="mb-8 inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700 md:mb-10"
          >
            全部分类
            <i className="ri-arrow-right-up-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <a
              key={c.slug}
              href="#latest"
              className="group relative flex items-center gap-4 overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-3 transition hover:-translate-y-0.5 hover:border-primary-200"
            >
              <span className="relative h-24 w-24 shrink-0 overflow-hidden rounded-xl md:h-28 md:w-28">
                <img
                  src={c.img}
                  alt={`${c.name}分类图集封面`}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute inset-0 flex items-center justify-center bg-foreground-950/15 text-background-50">
                  <i className={`${c.icon} text-2xl`} />
                </span>
              </span>
              <span className="flex min-w-0 flex-1 flex-col py-1">
                <span className="flex items-center gap-2">
                  <span className="truncate font-heading text-lg font-bold text-foreground-950">{c.name}</span>
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-800">
                    {c.count.toLocaleString()} 图集
                  </span>
                </span>
                <span className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-500">{c.desc}</span>
                <span className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-primary-500 opacity-0 transition group-hover:opacity-100">
                  进入分类
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}